import { Ripple } from 'primereact/ripple';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';

// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { Icon } from '@marketplace/ui-elements';

import { translate } from '@marketplace/translate';

export const PaginationTemplate = {
  layout: 'RowsPerPageDropdown PrevPageLink PageLinks NextPageLink ',
  PrevPageLink: (options: any) => {
    return (
      <button
        type="button"
        className={options.className}
        onClick={options.onClick}
        disabled={options.disabled}
      >
        <Icon glyph={Icon.glyphs.font['pi-angle-left']} />
        <Ripple />
      </button>
    );
  },
  NextPageLink: (options: any) => {
    return (
      <button
        type="button"
        className={options.className}
        onClick={options.onClick}
        disabled={options.disabled}
      >
        <Icon glyph={Icon.glyphs.font['pi-angle-right']} />
        <Ripple />
      </button>
    );
  },
  PageLinks: (options: any) => {
    if (
      (options.view.startPage === options.page &&
        options.view.startPage !== 0) ||
      (options.view.endPage === options.page &&
        options.page + 1 !== options.totalPages)
    ) {
      const className = classNames(options.className, { 'p-disabled': true });

      return (
        <span className={className} style={{ userSelect: 'none' }}>
          ...
        </span>
      );
    }

    return (
      <button
        type="button"
        className={options.className}
        onClick={options.onClick}
      >
        {options.page + 1}
        <Ripple />
      </button>
    );
  },
  RowsPerPageDropdown: (options: any) => {
    const dropdownOptions = [
      { label: 10, value: 10 },
      { label: 20, value: 20 },
      { label: 50, value: 50 },
    ];

    return (
      <>
        <div className="per-page-text">
          {translate('admin_table_paginations')}
        </div>
        <Dropdown
          value={options.value}
          options={dropdownOptions}
          onChange={options.onChange}
          appendTo={document.body}
        />
      </>
    );
  },
};
